import { Dialog, DialogModule } from "@angular/cdk/dialog";
import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ButtonConfig, Client, Job, VoyseComponent } from "@interfaces";
import { GtagService } from "src/app/containers/gtag/gtag.service";
import { ReferralFormComponent } from "src/app/dialogs/referral-form/referral-form/referral-form.component";
import { calculateButtonClasses, calculateButtonStyle } from "src/app/helpers/buttons";
import { SubdomainService } from "src/app/rest/subdomain.service";

@Component({
    selector: "app-refer-button",
    standalone: true,
    imports: [CommonModule, DialogModule,  ReferralFormComponent],
    templateUrl: "./refer-button.component.html",
})
export class ReferButtonComponent implements OnInit {
    @Output() onClick = new EventEmitter();
    @Input() component: VoyseComponent;
    @Input() buttonConfig: ButtonConfig;
    @Input() job: Job;
    public client: Client;
    public buttonStyle = {};
    public buttonClasses = [];

    constructor(
        private dialog: Dialog,
        private subdomain: SubdomainService,
        protected gtag: GtagService,
    ) {
        this.subdomain.getClient().subscribe((client: Client) => {
            this.client = client;
        });
    }

    ngOnInit() {
        this.buttonStyle = calculateButtonStyle(this.buttonConfig, this.client);
        this.buttonClasses = calculateButtonClasses(this.buttonConfig);
    }


    public openReferDialog() {
        this.onClick.emit();
        this.dialog.open(ReferralFormComponent, {
            width: '750px',
            maxWidth: '95vw',
            maxHeight: '85vh',
            panelClass: 'low-padding-dialog', 
            data: { job: this.job }
        });

        this.gtag.fireOpenReferDialogEvent(this.job._id, this.job.title);

    }
}
